import { render } from "./GroupsIndex.vue?vue&type=template&id=631d77ea"
import script from "./GroupsIndex.vue?vue&type=script&lang=js"
export * from "./GroupsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__